import React, { useReducer, createContext } from "react";
import { login_login_user } from "../../pages/auth/types/login";
import isValidJwt from "../../utils/isValidJwt";

export enum AuthForms {
  SIGN_IN,
  FORGOT_PASSWORD,
}

export enum AuthActions {
  SIGN_IN,
  SING_OUT,
  TOGGLE_FORM,
}
export interface IAuthState {
  isAuthenticated?: boolean | false;
  user?: login_login_user | null;
  currentForm?: AuthForms | AuthForms.SIGN_IN;
  accessToken?: string | "" | null;
  refreshToken?: string | "" | null;
}

export interface IAction {
  type: AuthActions;
  payload?: IAuthState | null;
}

const INITIAL_STATE: IAuthState = {
  isAuthenticated: isValidJwt(localStorage.getItem("accessToken")),
  user: JSON.parse(localStorage.getItem("user") || "{}"),
  currentForm: AuthForms.SIGN_IN,
  accessToken: localStorage.getItem("accessToken") || "",
  refreshToken: localStorage.getItem("refreshToken") || "",
};

function reducer(state: IAuthState, action: IAction): IAuthState {
  switch (action.type) {
    case AuthActions.SIGN_IN:
      localStorage.setItem("accessToken", action.payload?.accessToken || "");
      localStorage.setItem("refreshToken", action.payload?.refreshToken || "");
      action.payload?.user &&
        localStorage.setItem(
          "user",
          JSON.stringify(action.payload?.user) || ""
        );
      return {
        ...state,
        ...action.payload,
        isAuthenticated: true,
      };
    case AuthActions.SING_OUT:
      localStorage.removeItem("accessToken");
      localStorage.removeItem("refreshToken");
      localStorage.removeItem("user");
      // Keshlangan ruxsatlar keyingi foydalanuvchiga o'tib qolmasligi kerak
      localStorage.removeItem("allowed_modules");
      localStorage.removeItem("is_super_admin");
      return {
        ...INITIAL_STATE,
        isAuthenticated: false,
      };
    case AuthActions.TOGGLE_FORM:
      const formType =
        state.currentForm === AuthForms.FORGOT_PASSWORD
          ? AuthForms.SIGN_IN
          : AuthForms.FORGOT_PASSWORD;
      return {
        ...state,
        currentForm: formType,
      };
    default:
      return state;
  }
}

function useAuthReducer() {
  const [authState, authDispatch] = useReducer(reducer, INITIAL_STATE);
  return {
    authState,
    authDispatch,
  };
}

export const AuthContext = createContext(
  {} as ReturnType<typeof useAuthReducer>
);

export const AuthProvider: React.FunctionComponent = ({ children }) => {
  const { authState, authDispatch } = useAuthReducer();
  return (
    <AuthContext.Provider value={{ authState, authDispatch }}>
      {children}
    </AuthContext.Provider>
  );
};
